import React from 'react';
import { Form } from 'react-bootstrap';

const OPCOES_TIPO = [
  { valor: 'C', label: 'Contas' },
  { valor: 'A', label: 'Ativo' },
  { valor: 'B', label: 'Venda/Imóvel' },
  { valor: 'M', label: 'Mata' },
  { valor: 'N', label: 'Negócio' },
  { valor: 'D', label: 'Despesa' },
];

const SelectorTipoDigitalizacao = ({ tipo, onChange }) => (
  <div className="d-flex flex-wrap" style={{ gap: '12px' }}>
    {OPCOES_TIPO.map((op) => (
      <Form.Check
        key={op.valor}
        type="radio"
        id={`tipo-dig-${op.valor}`}
        label={op.label}
        name="tipo_digitalizacao"
        checked={tipo === op.valor}
        onChange={() => onChange(op.valor)}
        inline
      />
    ))}
  </div>
);

export default SelectorTipoDigitalizacao;
